import React from 'react';
import { formatMoney } from '../utils/utils.js';

const MoneyField = ({children, decimals}) => {
	let digits = decimals && 2;
	return (
		<div>
			{formatMoney(children, digits, ',', '.')}
		</div>
	);

}

export default MoneyField;


/** WEBPACK FOOTER **
 ** ./src/components/MoneyField.js
 **/